module.exports = __webpack_public_path__ + "static/siteImage-f34e98b2c59122c033bd51bfe56aead0.png";